<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>

    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
        @close="closeToast"
      />
    </div>

    <div
      v-if="!loader"
      class="sm:w-[760px] sm:mb-0 mb-16"
    >      
      <p class="text-lg font-medium text-black mb-2">Detalles adicionales</p>
      <p class="text-sm font-medium text-gray-400 mb-4">Este paso no es obligatorio llenarlo, puedes publicar tu propiedad sin haberlo llenado</p>
      <Accordion value="0">
        <!-- Amenidades Panel -->
        <AccordionPanel value="0">
          <AccordionHeader
            class="flex items-center justify-between w-full p-5 font-medium rtl:text-right  border border-b-0 border-gray-200 rounded-t-xl focus:ring-0 focus:ring-gray-200 hover:bg-gray-100 gap-3"
            data-accordion-target="#accordion-collapse-body-1"
            aria-expanded="true"
            aria-controls="accordion-collapse-body-1"
          >
            <button type="button">
              <div class="flex float-left text-gray-900">
                Amenidades
              </div>
            </button>
          </AccordionHeader>
          <AccordionContent>
            <div class="border p-5">
              <FormCharacteristicsComponent 
                :property-id="props.propertyId" 
                section="amenities"
                @trigger-update="handleUpdate"
              />
            </div>
          </AccordionContent>
        </AccordionPanel>

        <!-- Servicios Panel -->
        <AccordionPanel value="1">
          <AccordionHeader
            class="flex items-center justify-between w-full p-5 font-medium rtl:text-right  border border-b-0 focus:ring-0 focus:ring-gray-200 hover:bg-gray-100 gap-3"
            data-accordion-target="#accordion-open-body-2"
            aria-expanded="false"
            aria-controls="accordion-open-body-2"
          >
            <button type="button">
              <div class="flex float-left text-gray-900">
                Servicios
              </div>
            </button>
          </AccordionHeader>
          <AccordionContent>
            <div class="border p-5">
              <FormCharacteristicsComponent 
                :property-id="props.propertyId" 
                section="service"
                @trigger-update="handleUpdate"
              />
            </div>
          </AccordionContent>
        </AccordionPanel>

        <!-- Friendly Panel -->
        <AccordionPanel value="2">
          <AccordionHeader
            class="flex items-center justify-between w-full p-5 font-medium rtl:text-right  border border-b-0 focus:ring-0 focus:ring-gray-200 hover:bg-gray-100 gap-3"
            data-accordion-target="#accordion-open-body-3"
            aria-expanded="false"
            aria-controls="accordion-open-body-3"
          >
            <button type="button">
              <div class="flex float-left text-gray-900">
                Friendly
              </div>
            </button>
          </AccordionHeader>
          <AccordionContent>
            <div class="border p-5">
              <FormCharacteristicsComponent 
                :property-id="props.propertyId" 
                section="friendly"
                @trigger-update="handleUpdate"
              />
            </div>
          </AccordionContent>
        </AccordionPanel>

        <!-- Requisitos Panel -->
        <AccordionPanel value="3">
          <AccordionHeader
            class="flex items-center justify-between w-full p-5 font-medium rtl:text-right  border border-b-1 border-gray-200 focus:ring-0 focus:ring-gray-200 hover:bg-gray-100 gap-3"
          >
            <button type="button">
              <div class="flex float-left text-gray-900">
                Requisitos
              </div>
            </button>
          </AccordionHeader>
          <AccordionContent>
            <div class="border p-5 rounded-b-xl">
              <FormCharacteristicsComponent 
                :property-id="props.propertyId" 
                section="requeriments"
                @trigger-update="handleUpdate"
              />
            </div>
          </AccordionContent>
        </AccordionPanel>
      </Accordion>

      <div class="mt-6 hidden flex-col-1 justify-end items-end">
        <button
          class="w-full sm:w-auto px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-tuin-100 hover:bg-tuin_hover transition-colors"
          @click="save()"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Accordion from "primevue/accordion";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import ToastAlert from "@/commond/ToastAlert.vue";
import FormCharacteristicsComponent from "@/components/properties/FormCharacteristicsComponent.vue";
import LoaderTuin from "@/commond/LoaderTuin.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

let store = useStore();
let session = computed(() => store.getters.getUserSession);

const props = defineProps({
  propertyId: {
    type: Number,
    default: null
  }
});

const emit = defineEmits(['triggerUpdate']);

// Loading state
let loader = ref(false);

// Toast notifications
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

// Functions
async function save() {
  if (!props.propertyId) {
    showToast('error', 'ID de propiedad no válido');
    return;
  }

  loader.value = true;
  
  try {
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/save_features`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.post(url, {}, options);

    if (response.status === 200) {
      showToast('success', 'Características guardadas exitosamente');
      handleUpdate(props.propertyId);
      //emit('triggerUpdate', props.propertyId);
      return true;
    }
  } catch (error) {
    console.error('Error al guardar características:', error);
    return false;
    /*
    if (error.response?.status === 422) {
      showToast('error', error.response.data?.message || 'Error de validación');
    } else if (error.response?.status === 404) {
      showToast('error', 'Propiedad no encontrada');
    } else {
      showToast('error', 'Error al guardar las características');
    }*/
  } finally {
    loader.value = false;
  }
}

async function handleUpdate(propertyId) {
  //console.log('[ACCORDION_DETAILS_UPDATE]', propertyId);
  emit('triggerUpdate', propertyId);
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save
});
</script>

<style scoped>
/* Component specific styles if needed */
</style>
